import Vue from 'vue';

Vue.filter('cellphone', (value: string) => {
	if(!value)
	{
		return null;
	}

	return value.replace(/^(01[016789])(\d{3,4})(\d{4})$/gi, '$1-$2-$3');
});